export const markdownComponents = {
    a: ({ href, children }) => (
      <a
        href={href}
        className="underline text-blue-400 hover:text-blue-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    ),
  };
  
  export const parseMarkdownText = (text) => {
    return text?.replace(/\\n/g, '\n') || '';
  };
  